import { useEffect, useState } from "preact/hooks";
import { IReward } from "../interfaces";
import { IActionHandler, ICtaV2 } from "../interfaces/event-actions";
import { IFragment } from "../interfaces/fragment";
import {
  IAllGameLayouts,
  IAllIntroLayouts,
  IAllRewardLayouts,
} from "../interfaces/reward-fragments";

export const useRewardFragmentManager = (
  reward: IReward,
  fragment: { rootId: string }
): [
  typeof rootId,
  typeof root,
  typeof selectedFragment,
  typeof onRewardScreenAction
] => {
  const [screen, setScreen] = useState<"INTRO" | "GAME" | "REWARD">("INTRO");
  let selectedFragment:
    | IFragment<IAllIntroLayouts>
    | IFragment<IAllGameLayouts>
    | IFragment<IAllRewardLayouts> = null;

    useEffect(() => {
      if (!window || !document.addEventListener) return;

      const listener = (event: MessageEvent<ICtaV2>) => {
        console.log("--EVENT RECIVED--");
        console.log(event);
        if (!event.data) return;
        const cta = event.data;
        if (cta.target !== "STORE_V2") return;
        if (Array.isArray(cta.action)) return;
        onRewardScreenAction(cta.action);
      };
      window.addEventListener("message", listener);
      return () => window.removeEventListener("message", listener);
    }, []);

  if (reward && reward.layout && reward.layout) {
    const layout = reward.layout.layout;
    if (reward.experienceConsumed || screen === "REWARD") {
      if (layout.reward) selectedFragment = layout.reward;
      else selectedFragment = layout.game;
    } else {
      if (layout.intro && screen === "INTRO") selectedFragment = layout.intro;
      else if (layout.game) selectedFragment = layout.game;
      else selectedFragment = layout.reward;
    }
  }

  const onRewardScreenAction: IActionHandler = (action, details) => {
    if (action.store === "REWARD_SCREEN") {
      if (action.type === "REWARD_SCREEN CHANGE SCREEN") {
        setScreen(action.payload.screen);
      }
      if (details && details.onComplete) details.onComplete();
    }
  };

  let root: IAllGameLayouts | IAllIntroLayouts | IAllRewardLayouts = null;
  let rootId: string = null;
  if (selectedFragment) {
    rootId = selectedFragment.rootId;
    if (fragment && fragment.rootId) rootId = fragment.rootId;
    root = selectedFragment.byId[rootId];
  }
  return [rootId, root, selectedFragment, onRewardScreenAction];
};
